import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "focusPoint", "scrollTrigger" ]

  connect() {
    console.log("connected to scrollable controller")
    const self = this;
    this.element.dispatchEvent(new Event("scrollable::connected"))


    this.scrollTriggerTarget.addEventListener("scrollable::will-scroll", function() {
      self.scroll();
    })
  }

  scroll() {
    if(this.hasFocusPointTarget){
      this.focusPointTarget.scrollIntoView({ behavior: "smooth", block: "start" })
    }else{
      window.scrollTo(0, scrollTo)
    }
  }
}
